import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { dossierBasicInfoComponent } from './dossierBasicInfo.component';
import { UserModule } from '../../user/user/user.module';
import { DossierHeaderModule } from './dossierHeader.module';
import { SubHeaderModule } from '../../components/common/sub-header/sub-header.module';
import { TableComponentModule } from '../../main-view/table.module';
import { ButtonModule } from 'primeng-lts/button';
import { MenuModule } from 'primeng-lts/menu';
import { PanelModule } from 'primeng-lts/panel';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { DossierProgressGraphModule } from './dossierProgressGraph.module';
import { SargaProcurementProjectBasicInfoModule } from '../../../app/sarga/procurementProject/sargaProcurementProjectBasicInfo.module';
import { CixtecProcurementProjectBasicInfoModule } from '../../../app/cixtec/procurementProject/cixtecProcurementProjectBasicInfo.module';

import { DossierContractsProgressGraphModule } from './dossierContractsProgressGraph.module';
import { FrameworkAgreementProgressGraphModule } from './frameworkAgreementProgressGraph.module';
import { TableModule } from 'primeng-lts/table';

@NgModule({
  declarations: [dossierBasicInfoComponent],
  imports: [
    TranslateModule,
    CommonModule,

    PanelModule,
    MenuModule,
    DossierHeaderModule,
    UserModule,
    ButtonModule,
    SubHeaderModule,
    ScrollPanelModule,
    TableComponentModule,
    DossierProgressGraphModule,
    DossierContractsProgressGraphModule,
    FrameworkAgreementProgressGraphModule,
    TableModule
  ],
  exports: [dossierBasicInfoComponent]
})
export class DossierBasicInfoModule {
}
